function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var mdTableToJson = function mdTableToJson(mdString) {
  var learningObjectives = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];
  var headers;
  mdString.split('\n').filter(Boolean).forEach(function (line, lineNumber) {
    if (lineNumber === 0) {
      // Headers
      headers = line.split('|').filter(Boolean).map(function (item) {
        return item.trim();
      });
    } else if (lineNumber !== 1) {
      // Skip the -----
      var values = line.split('|').filter(Boolean).map(function (item) {
        return item.trim();
      });
      var resultLine = {};
      values.forEach(function (cell, index) {
        if (index === 0) {
          resultLine[headers[index]] = learningObjectives[lineNumber - 2]['name'];
        } else {
          resultLine[headers[index]] = cell;
        }
      });
      result.push(resultLine);
    }
  });

  // At this point the result is in this form
  // [
  //  {'Learning Outcome': 'Lo 1', 'pass': 'pass criteria 1', 'fail': 'fail criteria 1', 'average': 'average criteria 1'},
  //  {'Learning Outcome': 'Lo 2', 'pass': 'pass criteria 2', 'fail': 'fail criteria 2', 'average': 'average criteria 2'},
  //  {'Learning Outcome': 'Lo 3', 'pass': 'pass criteria 3', 'fail': 'fail criteria 3', 'average': 'average criteria 3'},
  // ]

  result = toRubricsFormat(result);
  return result;
};

/**
 * converts data from this format
 *  [
 *    {'Learning Outcome': 'Lo 1', 'pass': 'pass criteria 1', 'fail': 'fail criteria 1', 'average': 'average criteria 1'},
 *    {'Learning Outcome': 'Lo 2', 'pass': 'pass criteria 2', 'fail': 'fail criteria 2', 'average': 'average criteria 2'},
 *    {'Learning Outcome': 'Lo 3', 'pass': 'pass criteria 3', 'fail': 'fail criteria 3', 'average': 'average criteria 3'},
 *   ]
 *
 *   to
 *
 *   [
 *    {
 *      'Learning Outcome': 'Lo 1',
 *      'columns': [
 *        {name: 'pass', order: 0, value: 'pass criteria 1'},
 *        {name: 'fail', order: 1, value: 'pass criteria 2'},
 *        {name: 'pass', order: 2, value: 'pass criteria 2'}
 *      ]
 *    }
 *    {...}
 *   ]
 *
 * @param hashFormat []
 * @returns []
 */
export var toRubricsFormat = function toRubricsFormat(hashFormat) {
  return _toConsumableArray(hashFormat).map(function (item, index) {
    var data = {
      index: index
    };

    // The prompt is forced to make the first column 'Learning Outcome'
    data['Learning Outcome'] = item['Learning Outcome'] || item['Learning Outcomes'];
    delete item['Learning Outcome'];
    delete item['Learning Outcomes'];
    var columns = [];
    var columnCount = 0;
    for (var key in item) {
      var hash = {};
      hash['name'] = key;
      hash['value'] = item[key];
      hash['order'] = columnCount;
      hash['point'] = columnCount + 1;
      columns.push(hash);
      columnCount += 1;
    }
    data['columns'] = columns;
    return data;
  });
};